import React, { useEffect, useState } from 'react'
import { FiChevronDown } from "react-icons/fi";
import { FiChevronUp } from "react-icons/fi";
import { Link } from 'react-router-dom';


function SortFilter({products,setProducts}) {
    const [selectedSort, setSelectedSort] = useState('Sort');
    const [isVisibleFilter, setIsVisibleFilter] = useState(false);
    const [isRefineFilter, setIsRefineFilter] = useState(false);
    
      const handleSortChange = (event) => {
        setIsVisibleFilter(false);
        const sortType = event;
        var sortedProducts = [];
      
        switch (sortType) {
          case "lowtohigh":
              setSelectedSort('Price (Low to High )')
            // sortedProducts = products.sort((a, b) => a.price - b.price); // not working beacause sort not duplicating the array You should avoid mutating the state directly and instead create a new array when sorting/filtering.
            // sortedProducts = [...products].sort((a, b) => a.price - b.price);
            sortedProducts = [...products].sort((a, b) => a.variants.nodes[0].price.amount - b.variants.nodes[0].price.amount);


            break;
          case "hightolow":
              setSelectedSort('Price (High to Low)')
              // sortedProducts = [...products].sort((a, b) => b.price - a.price);
              sortedProducts = [...products].sort((a, b) => b.variants.nodes[0].price.amount - a.variants.nodes[0].price.amount);

              break;
          case "newArrival":
            setSelectedSort('Newly Added')
            // sortedProducts = products.filter(product => product.newArrival); // work because filter duplicate the array and 
            sortedProducts = products.filter(product => product.tags.includes("newArrival"));
            break;
          case "trendings":
            setSelectedSort('Revelance')
            // sortedProducts = products.filter(product => product.trending);
            sortedProducts = products.filter(product => product.tags.includes("trending"));
            break;
          case "bestSeller":
            setSelectedSort('Best Seller')
            // sortedProducts = products.filter(product => product.bestSeller);
            sortedProducts = products.filter(product => product.tags.includes("bestsellers"));

            break;
          case "stars":
            setSelectedSort(event)
            sortedProducts = [...products].sort((a, b) => a.price - b.price);
            break;
          case "latest":
            setSelectedSort(event)
            sortedProducts = products.filter(product => product.newArrival);
            sortedProducts =  [...products].sort((a, b) => b.created_at - a.created_at);

            break;
            case "all":
              setSelectedSort('All')
            sortedProducts = products
            break;
          default:
            sortedProducts = products;
        }
        setProducts(sortedProducts);
      };
 

const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      const scrollPosition = window.scrollY;
      if (scrollPosition > 100) {
        setIsScrolled(true);
      } else {
        setIsScrolled(false);
      }
    };

    window.addEventListener('scroll', handleScroll);

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);


  const categoryImages = [
    { name: 'Shirt', image: 'snitch-store009.jpg' },
    { name: 'T-Shirt', image: 'snitch-store010.jpg' },
    { name: 'Jeans', image: 'snitch-store011.jpg' },
    { name: 'Pants', image: 'snitch-store012.jpg' },
    { name: 'Shorts', image: 'snitch-store013.jpg' },
    { name: 'Coords', image: 'snitch-store014.jpg' },
    { name: 'Jacket', image: 'snitch-store015.jpg' },
    { name: 'Inner', image: 'snitch-store016.jpg' },
    { name: 'Shoes', image: 'snitch-store017.webp' },
    { name: 'Perfume', image: 'snitch-store018.jpg' },
    { name: 'Sunglasses', image: 'snitch-store019.jpg' },
    { name: 'Accessories', image: 'snitch-store020.webp' }
  ];
  

  const handleCategoryFilter = (value) => {
    const lowerCaseQuery = value?.toLowerCase().trim();
    const filteredProducts = products.filter((product) =>
        JSON.stringify(product)?.toLowerCase().includes(lowerCaseQuery)
      );
      setIsRefineFilter(false)
      setProducts(filteredProducts);
  }

  return (
    <div className={`filter-container  ${isScrolled ? 'fixed top-12 md:top-16 w-full bg-white shadow-md md:shadow-none z-40' : 'relative '}`}>
    <div  className="flex justify-center items-center px-2 container filter-box">
      <div className="w-1/2 revelance-container">
        <div className="relative font-primaryFont cursor-pointer group">
          <div onClick={() => setIsVisibleFilter(!isVisibleFilter)} className="flex justify-between items-center border-y-[1px] bg-white px-4 py-2 border-r-[1px]">
            <Link 
              className="lg:mx-4 py-2 font-medium text-base text-primary menu-hover"

            >
          {selectedSort || 'Sort'}
            </Link>
            <span>
              {/* <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                strokeWidth="1.5"
                stroke="currentColor"
                className="w-6 h-6"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  d="M19.5 8.25l-7.5 7.5-7.5-7.5"
                />
              </svg> */}
             { isVisibleFilter ? <FiChevronDown className="text-xl"/>
             : <FiChevronUp className="text-xl"/>}
            </span>
          </div>

          <div className={`z-50 absolute  flex-col bg-gray-100 shadow-xl px-4 py-1 w-full font-primaryFont text-gray-800 ${isVisibleFilter ? 'flex' : 'hidden'}`}>
         <Link   onClick={() => handleSortChange('all')} className="block border-gray-100 md:mx-2 my-2 py-1 border-b font-semibold text-gray-500 hover:text-black">
            All
           </Link>
           <Link   onClick={() => handleSortChange('latest')} className="block border-gray-100 md:mx-2 my-2 py-1 border-b font-semibold text-gray-500 hover:text-black">
          Latest
           </Link>
         <Link   onClick={() => handleSortChange('newArrival')} className="block border-gray-100 md:mx-2 my-2 py-1 border-b font-semibold text-gray-500 hover:text-black">
            Newly Added
           </Link>
           <Link  onClick={() => handleSortChange('bestSeller')}  className="block border-gray-100 md:mx-2 my-2 py-1 border-b font-semibold text-gray-500 hover:text-black">
              Best Seller
           </Link>

           <Link  onClick={() => handleSortChange('trendings')}  className="block border-gray-100 md:mx-2 my-2 py-1 border-b font-semibold text-gray-500 hover:text-black">
              Revelance
           </Link>

           <Link  onClick={() => handleSortChange('hightolow')}  className="block border-gray-100 md:mx-2 my-2 py-1 border-b font-semibold text-gray-500 hover:text-black">
            Price (High to Low)
           </Link>

           <Link  onClick={() => handleSortChange('lowtohigh')}  className="block border-gray-100 md:mx-2 my-2 py-1 border-b font-semibold text-gray-500 hover:text-black">
            Price (Low to High )
           </Link>

          

           
          </div>
        </div>
      </div>
      <div className="w-1/2 refine-by-container">
        <div className="relative cursor-pointer group">
          <div onClick={() => setIsRefineFilter(!isRefineFilter)} className="flex justify-between items-center border-y-[1px] bg-white px-4 py-2 font-primaryFont">
           <Link
              className="lg:mx-4 py-2 font-medium hover:font-semibold text-base text-primary menu-hover">
             Refine By
           </Link>
            <span>
            <svg
xmlns="http://www.w3.org/2000/svg"
fill="none"
viewBox="0 0 16 16"
className="w-6 h-6"
>
<path
strokeLinecap="round"
strokeLinejoin="round"
d="M0.8 3.2H3.348C3.6792 4.1288 4.5584 4.8 5.6 4.8C6.6416 4.8 7.5208 4.1288 7.852 3.2H15.2C15.6424 3.2 16 2.8424 16 2.4C16 1.9576 15.6424 1.6 15.2 1.6H7.852C7.5208 0.6712 6.6416 0 5.6 0C4.5584 0 3.6792 0.6712 3.348 1.6H0.8C0.3576 1.6 0 1.9576 0 2.4C0 2.8424 0.3576 3.2 0.8 3.2ZM15.2 12.8H7.852C7.5208 11.8712 6.6416 11.2 5.6 11.2C4.5584 11.2 3.6792 11.8712 3.348 12.8H0.8C0.3576 12.8 0 13.1576 0 13.6C0 14.0424 0.3576 14.4 0.8 14.4H3.348C3.6792 15.3288 4.5584 16 5.6 16C6.6416 16 7.5208 15.3288 7.852 14.4H15.2C15.6424 14.4 16 14.0424 16 13.6C16 13.1576 15.6424 12.8 15.2 12.8ZM15.2 7.2H12.652C12.3208 6.2712 11.4416 5.6 10.4 5.6C9.3584 5.6 8.4792 6.2712 8.148 7.2H0.8C0.3576 7.2 0 7.5576 0 8C0 8.4424 0.3576 8.8 0.8 8.8H8.148C8.4792 9.7288 9.3584 10.4 10.4 10.4C11.4416 10.4 12.3208 9.7288 12.652 8.8H15.2C15.6424 8.8 16 8.4424 16 8C16 7.5576 15.6424 7.2 15.2 7.2ZM5.6 1.6C6.0416 1.6 6.4 1.9584 6.4 2.4C6.4 2.8416 6.0416 3.2 5.6 3.2C5.1584 3.2 4.8 2.8416 4.8 2.4C4.8 1.9584 5.1584 1.6 5.6 1.6ZM5.6 14.4C5.1584 14.4 4.8 14.0416 4.8 13.6C4.8 13.1584 5.1584 12.8 5.6 12.8C6.0416 12.8 6.4 13.1584 6.4 13.6C6.4 14.0416 6.0416 14.4 5.6 14.4ZM10.4 8.8C9.9584 8.8 9.6 8.4416 9.6 8C9.6 7.5584 9.9584 7.2 10.4 7.2C10.8416 7.2 11.2 7.5584 11.2 8C11.2 8.4416 10.8416 8.8 10.4 8.8Z"
fill="#222222"
/>
            </svg>
            </span>
          </div> 

          <div className={`z-50 absolute  flex-col bg-gray-100 shadow-xl h-auto px-4 py-1 w-full font-primaryFont text-gray-800 ${isRefineFilter ? 'flex' : 'hidden'}`}>
      {categoryImages.map((category, index) => (
        <Link
          key={index}
          onClick={() => handleCategoryFilter(category.name)}
          className="block border-gray-100 md:mx-2 my-2 py-1 border-b font-semibold text-gray-500 hover:text-black"
        >
          {category.name}
        </Link>
      ))}
    </div>

        </div>
      </div>
    </div>
  </div>
  )
}

export default SortFilter